import "swiper/css";
import { Link } from "react-router-dom";
import { MdArrowOutward } from "react-icons/md";
import tag1 from "../.././assets/images/icon1.svg";
import tag2 from "../.././assets/images/icon2.svg";
import tag3 from "../.././assets/images/icon3.svg";
import "../../index"; 

const RecruitmentOverseasSection = ({ data = null }) => {
  const fallbackCards = [
    {
      icon: tag1,
      title: "Emigrant Services",
      subtitle: "Allows foreign nationals to work in a specific country for a set period based on employment opportunities.",
      link: "#",
      link_text: "Know More"
    },
    {
      icon: tag2,
      title: "Foreign Employer Services (FE)",
      subtitle: "A short-term visa allowing individuals to travel for leisure or tourism purposes, typically with restrictions on work.",
      link: "#",
      link_text: "Know More"
    },
    {
      icon: tag3,
      title: "Jobs Abroad",
      subtitle: "For individuals traveling to a country for business meetings, conferences, or related business activities with limited work rights.",
      link: "#",
      link_text: "Know More"
    },
  ];

  const cardsToRender = data?.cards && data.cards.length > 0 
    ? data.cards.map((c, i) => ({
        icon: c.image_url || (i === 0 ? tag1 : i === 1 ? tag2 : tag3),
        title: c.title,
        subtitle: c.description,
        link: c.link || "#",
        link_text: c.link_text || "Know More"
      }))
    : fallbackCards;

  return (
    <section className="relative font-manrope max-w-7xl mx-auto lg:px-6 md:px-12 px-4 md:py-16 py-10">
      <div className="flex md:flex-row flex-col gap-8 lg:justify-center mb-12">
        {data?.title ? (
          <div dangerouslySetInnerHTML={{ __html: data.title }}></div>
        ) : (
          <h2 className="max-w-xl text-center xl:text-5xl md:text-4xl text-3xl font-extrabold my-4">
            <span className="text-primary-navyblue">Recruitment & </span>
            <span className="text-primary-red">Overseas </span>
            <span className="text-primary-navyblue">Employment </span>
          </h2>
        )}
      </div>

      <div className="hover:text-primary-white grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 xl:gap-10 lg:gap-6 gap-10">
        {cardsToRender.map((job, index) => {
          const cardContent = (
            <div 
              className="group relative h-[333px] rounded-[30px] shadow-md border border-[#0E313A4D] overflow-hidden bg-white cursor-pointer"
              style={{ isolation: 'isolate' }}
            >
              
              {/* 1. THE EXPANDING CIRCLE (Origin: Arrow Position) */}
              <div className="absolute xl:bottom-12 lg:bottom-6 md:bottom-10 bottom-10 xl:left-10 lg:left-6 left-8 z-0 pointer-events-none">
                <span className="block w-8 h-8 rounded-full bg-primary-navyblue transition-transform duration-700 ease-in-out group-hover:scale-[50] group-hover:bg-primary-red"></span>
              </div>

              {/* 2. CONTENT LAYER (z-10 and relative) */}
              <div className="relative z-10 flex flex-col justify-between h-full xl:py-12 lg:p-6 py-10 xl:px-10 px-8 pointer-events-none">
                
                <div className="flex items-center gap-4">
                  {/* Icon transition */}
                  <img 
                    src={job.icon} 
                    alt="icon" 
                    className="w-12 h-12 transition-all duration-500 group-hover:invert group-hover:brightness-200 object-contain" 
                  />
                  <h3 className="text-[22px] font-extrabold text-primary-navyblue transition-colors duration-500 group-hover:text-primary-white">
                    {job.title}
                  </h3>
                </div>

                <p className="text-[16px] font-medium text-primary-gray transition-colors duration-500 group-hover:text-gray-200 line-clamp-3">
                  {job.subtitle}
                </p>

                <div className="flex items-center gap-2 pt-3">
                  {/* Visible Arrow Icon */}
                  <div className="w-8 h-8 flex items-center justify-center rounded-full transition-all duration-500 group-hover:bg-primary-navyblue">
                    <MdArrowOutward className="text-primary-white text-xl transition-transform duration-500 group-hover:rotate-45" />
                  </div>
                  
                  <span className="text-[15px] text-primary-navyblue font-extrabold transition-colors duration-500 group-hover:text-primary-white ml-2">
                    {job.link_text}
                  </span>
                </div>
              </div>
            </div>
          );

          return job.link.startsWith('http') ? (
            <a key={index} href={job.link} target="_blank" rel="noopener noreferrer">
              {cardContent}
            </a>
          ) : (
            <Link key={index} to={job.link}>
              {cardContent}
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default RecruitmentOverseasSection;
